module.exports = __webpack_public_path__ + "fonts/Abel-400-latin1.55d912c.woff2";